<template>
  <div class="AccountForms">
    <div class="panels">
      <AddressPanel
          class="address-panel"
          :title="`Adres dostawy`"
          :loadingEditAccount=true
          :loading=true
      />
      <div class="invoice-question">
        <span class="title">Potrzebujesz faktury do zamówienia?</span>
        <span class="description">
          Jeśli podczas zakupu nie uzupełnisz danych do faktury,
          to dokument sprzedaży zostanie wystawiony na Dane odbiorcy przesyłki.
        </span>
        <div class="want-invoice-container">
          <div>
            <Checkbox/>
          </div>
          <span class="want-invoice-description">Zaznacz jeżeli chcesz fakturę</span>
        </div>
      </div>
      <PasswordPanel
          class="password-panel"
      />
    </div>
  </div>
</template>

<script>
import AddressPanel from './accountView/AddressPanel.vue'
import PasswordPanel from './accountView/PasswordPanel.vue'
import Checkbox from './input/Checkbox.vue'


import '../../node_modules/placeholder-loading/src/scss/placeholder-loading.scss'

export default {
  name: 'LoadingEditMyAccount',
  components: {
    AddressPanel,
    PasswordPanel,
    Checkbox
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.AccountForms {
  box-sizing: border-box;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  margin-top: 16px;

  .panels {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    grid-gap: 50px 200px;
    margin: 0 auto;

    // Mobile style
    @media (max-width: $phone-max-width) {
      display: flex;
      flex-direction: column;
      margin: 0 40px;
    }

    .invoice-question {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto 20px auto 20px 1fr;
      grid-column: 1;

      // Mobile style
      @media (max-width: $phone-max-width) {
        max-width: 80vw;
      }

      .title {
        grid-row-start: 1;
        color: darken(white, 18%);
      }

      .description {
        grid-row-start: 3;
        color: grey;
        letter-spacing: -0.1px;
      }

      .want-invoice-container {
        grid-row-start: 5;
        display: grid;
        grid-template-columns: auto 20px 1fr;

        .want-invoice-description {
          grid-column-start: 3;
          color: darken(white, 15%)
        }
      }
    }

    .password-panel{
      grid-column: 2;
      grid-row: 1;

      // Mobile style
      @media (max-width: $phone-max-width) {
        order: -1;
        max-height: 40px;
      }

    }

    .AddressPanel {
      &.billing-address {
        order: 1;
      }
    }

    .invoice-billing-address {
      grid-column: 1;
      order: 1;
    }

    .addresses {
      display: flex;

      .address-panel {
        width: 300px;
      }
    }
  }
}
  
.ph-item {
  direction: ltr;
  position: relative;
  padding: 0;
  overflow: hidden;
  margin-bottom: 0;
  background-color: transparent;
  border: none;
  border-radius: none;

  &::before{
      display: none;
  }

  .ph-row{
      margin: 0;
  }

  .ph-col-12{
      margin: 0;
      padding: 0;
  }

  .big{
    height: 18px;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
    background-color: #727271;
    margin: 0;
    width: 70%;
    margin-bottom: 7.3px;

    &::before{
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 50%;
      width: 500%;
      margin-left: -250%;
      -webkit-animation: phAnimation 0.8s linear infinite;
      animation: phAnimation 0.8s linear infinite;
      background: linear-gradient(
          to right,
      rgba(255, 255, 255, 0) 46%,
      rgba(255, 255, 255, 0.35) 50%,
      rgba(255, 255, 255, 0) 54%) 50% 50%;
      z-index: 0;
    }
  }

  .gold{
    background-color: #d6ae5d;
    margin-top: 6px;
    width: 45%;
    margin-bottom: 0;
  }

  .ph-item > * {
    padding: 0;
  }
}

@media screen and (max-width: $phone-max-width) {
  .AccountForms {
    margin-bottom: 50px;
    .panels {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      grid-gap: 50px 200px;
      max-width: 500px;

      .password-panel{
        grid-column: 1;
        height: 35px;
      }

      .password-panel-open{
        height: auto;
      }

      .AddressPanel {
        &.billing-address {
          order: initial;
        }
      }

      .invoice-billing-address {
        order: initial;
      }
    }
  }
}

@media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .AccountForms {
    margin-bottom: 50px;
    .panels {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      grid-gap: 50px 200px;
      max-width: 500px;

      .password-panel{
        grid-column: 1;
        height: 35px;
      }

      .password-panel-open{
        height: auto;
      }

      .AddressPanel {
        &.billing-address {
          order: initial;
        }
      }

      .invoice-billing-address {
        order: initial;
      }
    }
  }
}
</style>